import { Component } from '@angular/core';

@Component({
  selector: 'pulse-front-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'panel-b2b';
}
